const prependHttpScheme = url => {
  if (!url) {
    return undefined;
  }

  if (url.match(/^https?:\/\//i)) {
    // We need to lowercase the protocol so it gets accepted by MAI
    return `${url.substring(0, 5).toLowerCase()}${url.substring(5)}`;
  }

  return `http://${url}`;
};

export default prependHttpScheme;
